import { Tooltip } from "@mui/material"
import { machineStatus } from "../../../../../explorer/types/SpareParts"
import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { AppIconsDelivery, AppIconsElaborated, AppIconsInstallation2, AppIconsOrderRecived, AppIconsQuery } from "../../../../components/AppIcons";
type TIBASProps = {
    status: machineStatus
}



function renderMachineStatusIcon(status: machineStatus) {

    

    switch (status) {
        case machineStatus.installed:
            return <AppIconsElaborated />;
        case machineStatus.shipped:
            return <AppIconsDelivery/>;
        case machineStatus.purchased:
            return <AppIconsOrderRecived/>;
        case machineStatus.obsolete:
            return <AppIconsQuery/>
        case machineStatus.unknown:
            return <AppIconsInstallation2 />;
    }
}

const InstalledBaseAccordionStatus = (props: TIBASProps): JSX.Element => {
    const { t } = useTranslation();
    
    return (
        <Tooltip
            placement="top"
            children={renderMachineStatusIcon(props.status)}
            title={t(`common.spareparts.${machineStatus[props.status]}`)}
        />
    )
}

export default InstalledBaseAccordionStatus;